import { HttpMethod } from '../models/methods';

export interface Token {
	access_token: string;
	refresh_token: string;
}

export interface RequestData {
	payload?: any;
	method: HttpMethod;
}

export interface UrlConstant {
	path: string;
	method: HttpMethod;
}

export interface StatsModel {
	combination: string;
	yes: number;
	no: number;
	notAnswered: number;
	yesPercentage: number;
	noPercentage: number;
	notAnsweredPercentage: number;
}
export interface WerModel {
	language: string;
	averageWer: number;
	totalWordCount: number;
}
export interface LanguageOptionsModel {
	name: string;
	code: string;
}

export interface SessionModel {
	sessionId: string;
	distinctLanguages: string[];
	processStatus: string;
	dateAdded: string;
	lastChunkDateAdded: string;
	client: string;
	processedBy: string;
}

export interface Template {
	templateId: string;
	name: string;
	tags: { [key: string]: string }[];
	previousSimulations?: { sampleId: string; wer: number; bcapSessionId: string }[];
}

export interface HistoryOfRuns {
	templateResults: {
		wer: number;
		templateId: string;
		name: string;
	}[];
	date: Date;
	testName: string;
	testId: string;
}

export enum TestStatus {
	PENDING = 'pending',
	RUNNING = 'running',
	COMPLETED = 'completed',
	FAILED = 'failed',
}
export interface Test {
	testId: string;
	type: string;
	parentTestId: string;
	name: string;
	tags: { [key: string]: string }[];
	selectedTemplateId: string[];
	selectedSampleId: string;
	statistics?: { wer?: number; isTranslationRun?: boolean };
	historyOfRuns?: HistoryOfRuns[];
	testStatus?: TestStatus;
	translationResults?: any;
}

export interface Sample {
	sampleId: string;
	name: string;
	type: string;
	languages: string;
	groundtruth?: string;
	audioFileUrl?: string;
}
